import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Cpu } from "lucide-react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import { images, products } from "../mock/mock";

export default function Products() {
  return (
    <main>
      <PageHero image={images.heroEngine} eyebrow="Service" title="Our Engines" subtitle="A complete range of medium-speed liquid and gas fuelled engines for marine and land-based applications." />
      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-20">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((p) => (
              <div key={p.model} className="group border border-gray-100 rounded-xl overflow-hidden hover:shadow-xl transition-all">
                <div className="oe-navy p-6 flex items-center justify-between">
                  <div>
                    <h3 className="oe-display text-white text-2xl">{p.model}</h3>
                    <p className="text-white/60 text-xs uppercase tracking-wide mt-1">{p.type}</p>
                  </div>
                  <Cpu size={30} className="text-oe-red" />
                </div>
                <div className="p-6">
                  <div className="flex items-baseline gap-2 mb-4">
                    <span className="text-muted-foreground text-xs uppercase tracking-wide">Output</span>
                    <span className="text-oe-navy font-semibold">{p.output}</span>
                  </div>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-5">{p.desc}</p>
                  <Link to="/contact" className="inline-flex items-center gap-2 text-oe-navy font-semibold text-sm border-b-2 border-oe-red pb-1 group-hover:gap-3 transition-all">
                    Request a quote <ArrowRight size={15} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
}
